import { classNames } from "@ember-decorators/component";
import ColorPalettePickerRow from "./color-palette-picker/color-palette-picker-row";
import ComboBox from "./combo-box";
import { pluginApiIdentifiers } from "./select-kit";
const ColorPalettePicker = dt7948.c(class ColorPalettePicker extends ComboBox {
  modifyComponentForRow() {
    return ColorPalettePickerRow;
  }
}, [pluginApiIdentifiers(["color-palette-picker"]), classNames("color-palette-picker")]);
export default ColorPalettePicker;